const PAGETYPE = [{
  name: '产品详情页',
  key: 'DETAILS'
}, {
  name: '填写信息页',
  key: 'WRITE_PAGE_INFO'
}, {
  name: '确认信息页',
  key: 'CONFIRM_PAGE'
}, {
  name: '保费试算',
  key: 'TRIAL'
}, {
  name: '健康告知',
  key: 'INFORM'
}, {
  name: '落地页',
  key: 'LANDING_PAGE'
}, {
  name: '信息记录页',
  key: 'INFORECORD_PAGE'
}, {
  name: '产品列表页',
  key: 'PRODUCT_LIST_PAGE'
}, {
  name: '查询记录页',
  key: 'QUERY_INFO_PAGE'
}, {
  name: '退保填写页',
  key: 'POLICY_CANCEL_PAGE'
}, {
  name: '保单详情页',
  key: 'POLICY_DETAIL_PAGE'
}, {
  name: '发票填写页',
  key: 'INVOICE_PAGE'
}, {
  name: '开具发票页',
  key: 'INVOICE_LIST_PAGE'
}, {
  name: '开票记录页',
  key: 'INVOICE_RECORD_LIST_PAGE'
}, {
  name: '发票详情页',
  key: 'INVOICE_DETAIL_PAGE'
}];
const getSplitFun = val => {
  if (val) {
    if (val.indexOf(',') > -1) {
      return val.split(',');
    } else {
      return [val];
    }
  } else {
    return [];
  }
};
export { PAGETYPE, getSplitFun };